import { Component, Input, OnInit } from '@angular/core';

import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-back-button',
    template: `
        <div [ngClass]="{ 'backbutton-container': true, styled: container }">
            <button nbButton [size]="size" (click)="onClick()">
                <nb-icon icon="arrow-circle-left-outline"></nb-icon>
                {{ text }}
            </button>
        </div>
    `,
    styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent implements OnInit {
    @Input('text') text: string = this.translate.instant('BUTTONS.BACK');
    @Input('size') size: 'tiny' | 'small' | 'medium' | 'large' | 'giant' = 'small';
    @Input('container') container: boolean = false;
    @Input('route') route: string;
    constructor(private location: Location, private translate: TranslateService, private router: Router) {}

    ngOnInit(): void {}

    onClick() {
        // const { filterYear, filterMonth } = this.route.snapshot.queryParams;
        if (this.route) {
            this.router.navigate([this.route]);
        } else {
            this.location.back();
        }
    }
}
